module.exports = __webpack_public_path__ + "first-20_paper.jpg?3992982aa2df6b737c134a00146d64ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_paper.jpg
// module id = 502
// module chunks = 0